import useTicket from "@/hooks/useTicket";
import RechargeFinishedView from "./view";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getFormattedCart } from "@/utils/functions";
import { useState } from "react";

export default function RechargeFinished() {
  const navigate = useNavigate();
  const { 
    isLoading, 
    getTickets, 
    getInvoice, 
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
    customer,
  } = useTicket();

  const [error, setError] = useState<boolean>(false);

  const toggleError = () => setError(prev => !prev);

  const goBack = () => gotToHome();

  const gotToHome = () => navigate("/");

  const openInvoice = () => {
    getTickets(() => {
      const { total } = getFormattedCart({ cart: customer?.cart!, debts: customer?.debts! });
      const filteredItems = customer?.tickets?.filter(item => Number(item.price.replace(/,/g, '.')) === total && moment(item.fullDate).isAfter(moment().subtract(10, 'minutes'))) ?? [];
      const sortedTickets = [...filteredItems]?.sort((a, b) => {
        const dateA = moment(a?.fullDate);
        const dateB = moment(b?.fullDate);
        return dateB.diff(dateA);
      });
      if (!sortedTickets?.length) {
        toggleError();
        return;
      }
      getInvoice(sortedTickets?.[0]);
    });
  }

  return (
    <RechargeFinishedView
      goBack={goBack}
      gotToHome={gotToHome}
      invoice={invoice}
      toggleModal={toggleModal}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={error}
      toggleError={toggleError}
    />
  );
}
